export default __webpack_public_path__ + "static/media/requ.336639a4.png";